// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filter-row[data-v-2803f6b6] {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.stat-card[data-v-2803f6b6] {\n  text-align: center;\n  padding: 10px;\n}\n.stat-label[data-v-2803f6b6] {\n  font-size: 13px;\n  color: #909399;\n  margin-bottom: 8px;\n}\n.stat-value[data-v-2803f6b6] {\n  font-size: 28px;\n  font-weight: 600;\n  color: #303133;\n}\n.stat-sub[data-v-2803f6b6] {\n  font-size: 11px;\n  color: #909399;\n  margin-top: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
